// extracted by mini-css-extract-plugin
export default {"termsOfUseBox":"TermsOfUseStyles_termsOfUseBox__KFuEX","title":"TermsOfUseStyles_title__5DQiO"};